var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilService } from '@app/core';
import { finalize } from 'rxjs/operators';
import { LOCAL_VAR } from '@app/core';
import { FormBuilder } from '@angular/forms';
import { DealHelpComponent } from '@app/shared/modals/deal-help/deal-help.component';
import { DealsService } from '@app/core/service/deals.service';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { DateTime } from 'luxon';
var CancelContactComponent = /** @class */ (function () {
    function CancelContactComponent(modalService, utilService, authenticationService, formBuilder, _service) {
        this.modalService = modalService;
        this.utilService = utilService;
        this.authenticationService = authenticationService;
        this.formBuilder = formBuilder;
        this._service = _service;
        this.loggedInUserType = null;
        this.isLoading = false;
        this.perPage = 10;
        this.sortDir = -1;
        this.currentPage = 1;
        this.sortBy = 'createdAt';
        this.pager = {
            perPage: 10,
            currentPage: 1,
            Totalrecords: 0,
            TotalPages: 0
        };
        this.statusTypes = [
            { text: 'Step1 Completed', value: 'step1 completed' },
            { text: 'Proforma Generated', value: 'proforma generated' },
            { text: 'Agreement Generated', value: 'agreement generated' },
            { text: 'Agreement Pending', value: 'agreement pending' },
            { text: 'Approved', value: 'approved' },
            { text: 'Rejected', value: 'rejected' }
        ];
        this.currentStatus = '';
        this.user = this.authenticationService.credentials.user;
        // console.log(this.user)
        this.loggedInUserType = this.user.userRoleId.slug;
        localStorage.setItem(LOCAL_VAR.selectedAgency, null);
        this.createForm();
        this.getListByFilter();
    }
    CancelContactComponent.prototype.ngOnInit = function () { };
    CancelContactComponent.prototype.createForm = function () {
        var _this = this;
        this.fiterForm = this.formBuilder.group({
            dealerName: [''],
            dealerNumber: [''],
            date_from: [],
            date_to: [''],
            perPage: 10
        });
        this.fiterForm.valueChanges.subscribe(function (values) {
            //this.pager.currentPage = 1;
            //this.getListByFilter();
            var self = _this;
            clearInterval(self.timer);
            self.timer = setInterval(function () {
                clearInterval(self.timer);
                self.getListByFilter();
            }, 500);
        });
    };
    CancelContactComponent.prototype.getListByFilter = function () {
        var payload = this.getPayload();
        payload = this.utilService.removeEmpty(payload);
        if (payload.date_from) {
            payload.from = DateTime.fromObject(payload.date_from).toISO();
        }
        if (payload.date_to) {
            payload.to = new Date(new Date(DateTime.fromObject(payload.date_to).toISO()).setHours(23, 59, 59));
        }
        delete payload.date_from;
        delete payload.date_to;
        this.pager.perPage = payload.perPage;
        delete payload.perPage;
        this.getList(this.pager.currentPage, payload);
    };
    CancelContactComponent.prototype.getList = function (page, payload) {
        var _this = this;
        payload.currentPage = page;
        payload.perPage = this.pager.perPage;
        this.isLoading = true;
        this._service
            .getCancelContactByFilter(payload)
            .pipe(finalize(function () {
            _this.isLoading = false;
        }))
            .subscribe(function (response) {
            if (response.records) {
                _this.cancelformList = response.records;
                _this.renderPagination(response.page, response.total, response.totalPage);
            }
        }, function (error) {
            console.log('Deal list error:', error);
            _this.isLoading = false;
        });
    };
    CancelContactComponent.prototype.goPage = function () {
        var goto = this.nameInput.nativeElement.value;
        this.setPage(goto);
        this.nameInput.nativeElement.value = '';
    };
    CancelContactComponent.prototype.setPage = function (page) {
        if (0 < page &&
            page <= this.pager.TotalPages &&
            page != this.pager.currentPage) {
            this.pager.currentPage = page;
            this.getListByFilter();
        }
    };
    CancelContactComponent.prototype.renderPagination = function (page, total, totalPage) {
        this.pager.currentPage = page;
        this.pager.Totalrecords = total;
        this.pager.TotalPages = totalPage;
        this.PageList = this.utilService.getPageList(this.pager.TotalPages, this.pager.currentPage);
    };
    CancelContactComponent.prototype.getPayload = function () {
        var payload = JSON.parse(JSON.stringify(this.fiterForm.value));
        payload = this.utilService.removeEmpty(payload);
        return payload;
    };
    CancelContactComponent.prototype.omit_special_char = function (event) {
        var k;
        k = event.charCode; //         k = event.keyCode;  (Both can be used)
        return ((k > 64 && k < 91) ||
            (k > 96 && k <= 122) ||
            k == 8 ||
            k == 32 ||
            (k >= 48 && k <= 57));
    };
    CancelContactComponent.prototype.omit_special_Mailchar = function (event) {
        var k;
        k = event.charCode; //         k = event.keyCode;  (Both can be used)
        return ((k > 64 && k < 91) ||
            (k > 96 && k <= 122) ||
            k === 46 ||
            k === 64 ||
            k == 8 ||
            k == 32 ||
            (k >= 48 && k <= 57));
    };
    CancelContactComponent.prototype.openHelpPopup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var modalRef;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalService.open(DealHelpComponent)];
                    case 1:
                        modalRef = _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return CancelContactComponent;
}());
export { CancelContactComponent };
